
;
define("core", function(){});
